
import axios from 'axios';
import { createSlice } from '@reduxjs/toolkit';
import { setError } from './uiReducer';
import NotificationService from '../services/NotificationService';
import { APPOINTMENTS_PAGE_SIZE } from '../constants/AppConstants';
import * as DataHelpers from '../helpers/DataHelpers';

const appointmentRemindersSlice = createSlice({
  name: 'APPOINTMENTREMINDERS',
  initialState: {
    appointmentCampaigns: [],
    loading: true,
  },
  reducers: {
    receiveAppointmentCampaigns: (state, action) => ({
      ...state,
      appointmentCampaigns: action.payload.pageNumber > 0 ?
        DataHelpers.mergeArrays(state.appointmentCampaigns, action.payload.appointmentCampaigns) : action.payload.appointmentCampaigns,
      activeCampiagnId: action.payload.activeCampiagnId,
      loading: false,
    }),
    requestData: state => ({
      ...state,
      loading: true,
    }),
    receiveError: state => ({
      ...state,
      loading: false,
    }),
  },
});

export default appointmentRemindersSlice.reducer;

// ACTIONS
export const { receiveAppointmentCampaigns, requestData, receiveError } = appointmentRemindersSlice.actions;

// THUNKS -- ASYNC ACTION CREATORS

export function fetchAppointmentCampaigns({ orgId, pageNumber = 0, pageSize = APPOINTMENTS_PAGE_SIZE, templateId }) {
  return (dispatch) => {
    dispatch(requestData());
    return getAppointmentCampaigns({ orgId, pageNumber, pageSize, templateId })
      .then((response) => {
        dispatch(receiveAppointmentCampaigns({ appointmentCampaigns: response.data, pageNumber, ...templateId && { activeCampiagnId: parseInt(templateId, 10) } }));
      }).catch((err) => {
        dispatch(receiveError());
        dispatch(setError(err));
      });
  };
}

export function createAppointmentCampaign(orgId, payload) {
  return dispatch => postAppointmentCampaign(orgId, payload)
    .then((response) => {
      NotificationService('createAppointmentCampaign', response);
      return response;
    }).catch((err) => {
      NotificationService('createAppointmentCampaign', err.response);
      dispatch(receiveError());
      dispatch(setError(err));
    });
}

export function updateAppointmentCampaign(orgId, payload) {
  return dispatch => patchAppointmentCampaign(orgId, payload)
    .then((response) => {
      NotificationService('updateAppointmentCampaign', response);
      return response;
    }).catch((err) => {
      NotificationService('updateAppointmentCampaign', err.response);
      dispatch(receiveError());
      dispatch(setError(err));
    });
}

export function deleteAppointmentCampaign(orgId, templateId) {
  return dispatch => deleteAppointmentCampaignById(orgId, templateId)
    .then((response) => {
      NotificationService('deleteAppointmentCampaign', response);
      return response;
    }).catch((err) => {
      NotificationService('deleteAppointmentCampaign', err.response);
      dispatch(receiveError());
      dispatch(setError(err));
    });
}

function getAppointmentCampaigns({ orgId, pageSize, templateId, pageNumber }) {
  return axios.get(`/appointment/${orgId}/templates?page=${pageNumber}&pageSize=${pageSize}`, {
    params: {
      orgId,
      id: templateId,
    },
  });
}

function postAppointmentCampaign(orgId, payload) {
  return axios.post(`/appointment/${orgId}/templates`, payload);
}

function patchAppointmentCampaign(orgId, payload) {
  return axios.patch(`/appointment/${orgId}/templates/${payload.id}`, payload);
}
function deleteAppointmentCampaignById(orgId, templateId) {
  return axios.delete(`/appointment/${orgId}/templates/${templateId}`);
}
